import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { userByIdPreview } from "../actions/userById";
import { propertyImpressions } from "../actions/propertyImpression";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CardSkeleton from "./CardSkeleton";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";
import { getDisplayName } from "../utils/displayName";
const PropColumn = ({ property }) => {
  const nav = useNavigate();
  const [poster, setPoster] = useState(null);
  useEffect(() => {
    const uid = property?.user_id;
    if (uid && /^\d+$/.test(String(uid))) {
      userByIdPreview(uid, { setPoster });
    } else {
      if (process.env.NODE_ENV !== "production") {
        if (uid !== undefined && uid !== null) {
          console.warn(
            "PropColumn: skipping userByIdPreview for invalid user_id:",
            uid,
          );
        }
      }
    }
  }, [property?.user_id]);
  const handleClick = (property_id) => {
    if (!property_id || !/^\d+$/.test(String(property_id))) {
      if (process.env.NODE_ENV !== "production") {
        console.warn(
          "PropColumn: invalid property_id, navigation prevented:",
          property_id,
        );
      }
      return;
    }
    propertyImpressions(property_id);
    nav(`/property/${property_id}`);
  };
  function currencyFormat(num) {
    if (num === null || num === undefined || num === "") {
      return "$0?";
    }
    const value = Number(num);
    if (Number.isNaN(value)) {
      return "$0?";
    }
    const money =
      "$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return money.substring(0, money.length - 3);
  }
  return (
    <>
      <div
        className="bg-white relative flex flex-row shadow-lg rounded-lg overflow-hidden h-[260px] hover:shadow-xl hover:scale-[1.03] hover:cursor-pointer transition-all group w-full max-w-[480px]"
        onClick={() => handleClick(property?.property_id)}
      >
        {/* Status Ribbon - Info Section Only */}
        <div className="absolute top-0 left-0 right-[200px] z-20">
          {property?.property_status === "Not Active" ? (
            <div className="bg-red-600 text-white px-4 py-1.5 text-xs font-bold shadow-md w-full flex items-center justify-between">
              <span>Off Market</span>
              {property?.type && (
                <span
                  className={`px-2 py-0.5 rounded text-[10px] ${
                    property.type === "Residential"
                      ? "bg-blue-500"
                      : property.type === "Commercial"
                        ? "bg-purple-500"
                        : "bg-gray-500"
                  }`}
                >
                  {property.type}
                </span>
              )}
            </div>
          ) : property?.property_status === "Leased" ? (
            <div className="bg-red-600 text-white px-4 py-1.5 text-xs font-bold shadow-md w-full flex items-center justify-between">
              <span>Leased</span>
              {property?.type && (
                <span
                  className={`px-2 py-0.5 rounded text-[10px] ${
                    property.type === "Residential"
                      ? "bg-blue-500"
                      : property.type === "Commercial"
                        ? "bg-purple-500"
                        : "bg-gray-500"
                  }`}
                >
                  {property.type}
                </span>
              )}
            </div>
          ) : property?.property_status === "Sold" ? (
            <div className="bg-red-600 text-white px-4 py-1.5 text-xs font-bold shadow-md w-full flex items-center justify-between">
              <span>Sold</span>
              {property?.type && (
                <span
                  className={`px-2 py-0.5 rounded text-[10px] ${
                    property.type === "Residential"
                      ? "bg-blue-500"
                      : property.type === "Commercial"
                        ? "bg-purple-500"
                        : "bg-gray-500"
                  }`}
                >
                  {property.type}
                </span>
              )}
            </div>
          ) : property?.property_status === "Pending" ? (
            <div className="bg-yellow-600 text-white px-4 py-1.5 text-xs font-bold shadow-md w-full flex items-center justify-between">
              <span>Pending</span>
              {property?.type && (
                <span
                  className={`px-2 py-0.5 rounded text-[10px] ${
                    property.type === "Residential"
                      ? "bg-blue-500"
                      : property.type === "Commercial"
                        ? "bg-purple-500"
                        : "bg-gray-500"
                  }`}
                >
                  {property.type}
                </span>
              )}
            </div>
          ) : property?.property_status === "Active" ? (
            (() => {
              const listedDate = new Date(property?.listed_date);
              const now = new Date();
              const daysSinceListed = Math.floor(
                (now - listedDate) / (1000 * 60 * 60 * 24),
              );
              const isNew = daysSinceListed <= 7;
              const forType =
                property?.for === "Sale"
                  ? "For Sale"
                  : property?.for === "Lease"
                    ? "For Lease"
                    : "Active";

              return (
                <div className="bg-green-600 text-white px-4 py-1.5 text-xs font-bold shadow-md w-full flex items-center justify-between">
                  <span>{forType}</span>
                  <div className="flex items-center gap-2">
                    {property?.type && (
                      <span
                        className={`px-2 py-0.5 rounded text-[10px] ${
                          property.type === "Residential"
                            ? "bg-blue-500"
                            : property.type === "Commercial"
                              ? "bg-purple-500"
                              : "bg-gray-500"
                        }`}
                      >
                        {property.type}
                      </span>
                    )}
                    {isNew && (
                      <span className="bg-green-500 px-2 py-0.5 rounded text-[10px]">
                        NEW
                      </span>
                    )}
                  </div>
                </div>
              );
            })()
          ) : property?.for === "Sale" ? (
            <div className="bg-green-600 text-white px-4 py-1.5 text-xs font-bold shadow-md w-full">
              <div className="flex items-center gap-2">
                {property?.property_status &&
                  property?.property_status !== "Active" && (
                    <span className="font-bold uppercase bg-gray-700 text-white rounded-lg px-2 py-0.5 text-[10px]">
                      {property.property_status}
                    </span>
                  )}
                <span>For Sale</span>
              </div>
            </div>
          ) : property?.for === "Lease" ? (
            <div className="bg-green-600 text-white px-4 py-1.5 text-xs font-bold shadow-md w-full">
              <div className="flex items-center gap-2">
                {property?.property_status &&
                  property?.property_status !== "Active" && (
                    <span className="font-bold uppercase bg-gray-700 text-white rounded-lg px-2 py-0.5 text-[10px]">
                      {property.property_status}
                    </span>
                  )}
                <span>For Lease</span>
              </div>
            </div>
          ) : null}
        </div>

        {/* Left Side - Info */}
        <div className="flex-1 flex flex-col justify-between p-3 pr-2 min-w-0">
          {/* Price */}
          <div className="mt-5">
            {property?.property_status === "Leased" ? (
              <>
                <h2 className="text-3xl font-bold text-gray-900 mb-1">
                  {currencyFormat(property?.price)}
                  {property?.for === "Lease" && (
                    <span className="text-lg font-normal text-gray-600">
                      /mo
                    </span>
                  )}
                </h2>
                <p className="text-sm font-semibold text-blue-700">
                  Leased Price:{" "}
                  {property?.sold_for
                    ? currencyFormat(property?.sold_for)
                    : "N/A"}
                  {property?.for === "Lease" && (
                    <span className="text-xs font-normal text-gray-600">
                      /mo
                    </span>
                  )}
                </p>
              </>
            ) : (
              <h2 className="text-3xl font-bold text-gray-900 mb-1">
                {currencyFormat(property?.price)}
                {property?.for === "Lease" && (
                  <span className="text-lg font-normal text-gray-600">/mo</span>
                )}
              </h2>
            )}

            {/* Address */}
            <div>
              <p className="text-base text-gray-700 font-medium truncate">
                {[
                  property?.street_number,
                  property?.dir_prefix &&
                  property?.dir_prefix !== "None-will not show"
                    ? property?.dir_prefix
                    : null,
                  property?.street_name,
                ]
                  .filter(Boolean)
                  .join(" ")}
              </p>
              <p className="text-base text-gray-600 truncate">
                {property?.city}, TX {property?.zip}
              </p>

              {/* Unit and residential subtype displayed under address */}
              {property?.unit_number && (
                <div className="mt-1">
                  <span className="text-sm text-gray-700">
                    Unit# {property.unit_number}
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Property Details */}
          {/* Residential Subtype - moved above the details block */}
          {property?.residentialSubtype && (
            <div className="text-sm text-blue-700 font-semibold mb-1">
              Type: {property.residentialSubtype}
            </div>
          )}
          <div className="space-y-1">
            <div className="flex items-center gap-1.5 text-sm text-gray-700 whitespace-nowrap overflow-hidden">
              <span className="inline-flex items-center gap-0.5">
                <span className="font-semibold">{property?.beds_total}</span>
                <span className="text-gray-500">Bd</span>
              </span>
              <span className="text-gray-400">·</span>
              <span className="inline-flex items-center gap-0.5">
                <span className="font-semibold">{property?.baths_full}</span>
                <span className="text-gray-500">Ba</span>
              </span>
              <span className="text-gray-400">·</span>
              <span className="inline-flex items-center gap-0.5">
                <span className="font-semibold">
                  {property?.living_sqft?.toLocaleString()}
                </span>
                <span className="text-gray-500">SF</span>
              </span>
            </div>
            {/* Agent Info */}
            <div className="text-sm text-gray-700">
              <span className="font-medium block overflow-hidden text-ellipsis whitespace-nowrap">
                {getDisplayName(poster)}
              </span>
            </div>
          </div>
        </div>

        {/* Right Side - Image */}
        <div className="w-[200px] flex-shrink-0 relative overflow-hidden">
          <img
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
            src={cloudinaryUrl(property?.media_url?.split(",")[0])}
            alt="Property Preview"
          />
          <div className="absolute inset-0 bg-gradient-to-l from-transparent to-black/5 group-hover:to-black/0 transition-all"></div>
        </div>
      </div>
    </>
  );
};

export default PropColumn;
